export const createRootStyles = (root: { [key: string]: string }) => {
  if (!root) return '';
  if (Object.keys(root)?.length === 0) return '';
  return Object.entries(root).reduce<string>((acc, [key, value]) => {
    if (!key.startsWith('--')) return acc;
    return `${acc} ${key}: ${value};`;
  }, '');
};
